import React from "react";

const Metro = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26.023"
    height="26.022"
    viewBox="0 0 26.023 26.022"
  >
    <g
      id="Group_57632"
      data-name="Group 57632"
      transform="translate(-299.5 -1876.595)"
    >
      <path
        id="Path_36325"
        data-name="Path 36325"
        d="M31.279,26.757A12.511,12.511,0,1,1,43.791,14.245,12.526,12.526,0,0,1,31.279,26.757"
        transform="translate(281.232 1875.36)"
        fill="none"
        stroke="#1a1818"
        strokeWidth="1"
      />
      <path
        id="Path_36326"
        data-name="Path 36326"
        d="M42.055,42.153l6.107-5.24H40.543l-5.4-5.409H35.14l0,0,0,0,5.209-5.239h6.8L41.047,31.5h7.619l5.4,5.41h.007l0,0,0,0L48.86,42.153ZM47.7,36.4l-4.217-4.217a.6.6,0,0,0-.428-.177H41.508l4.2,4.2a.671.671,0,0,0,.475.2Zm.483.492,0,0,0,0Z"
        transform="translate(267.907 1855.4)"
        // fill="#1a1818"
      />
    </g>
  </svg>
);

export default Metro;
